module.exports = __webpack_public_path__ + "img/circled-stripe.5ab4a736.svg";